import Hero from './components/Hero';
import BusinessCards from './components/BusinessCards';
import StatsSection from './components/StatsSection';
import Partners from './components/Partners';
import NewsPreview from './components/NewsPreview';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Hero />
      <BusinessCards />
      <StatsSection />
      <Partners />
      <NewsPreview />
      <CTASection />
    </>
  );
}